import api from '@/lib/api';
import type { AdminUser, PageResponse } from '@/types/admin.model';
import { toPageResponse } from '@/types/admin.model';

interface ListUsersParams {
  query?: string;
  page: number;
  size: number;
}

export const adminUsersApi = {
  listUsers: async ({
    query,
    page,
    size,
  }: ListUsersParams): Promise<PageResponse<AdminUser>> => {
    // No `fields` here on purpose: the backoffice endpoints pin their own
    // projection server-side (ControllerConstant.ADMIN_USER_FIELDS) and ignore
    // the query param, because a caller-chosen projection on a list of every
    // user could ask for the owners' MercadoPago OAuth tokens.
    const response = await api.get('/users/admin', {
      params: {
        query: query || undefined,
        page,
        size,
      },
    });
    return toPageResponse<AdminUser>(response.data);
  },

  // The detail screen is reachable by URL (shared link, new tab), so it cannot
  // depend on finding the user inside the first page of the list.
  getUser: async (pk: string): Promise<AdminUser> => {
    const response = await api.get(`/users/admin/${pk}`);
    return response.data;
  },

  banUser: async (pk: string): Promise<void> => {
    await api.patch(`/users/${pk}/ban`);
  },

  unbanUser: async (pk: string): Promise<void> => {
    await api.patch(`/users/${pk}/unban`);
  },

  grantOwnerRole: async (userEmail: string): Promise<void> => {
    await api.post('/users/owner', { userEmail });
  },

  revokeOwnerRole: async (pk: string): Promise<void> => {
    await api.delete(`/users/${pk}/roles/owner`);
  },
};
